/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from "prop-types";


export const WithConfirmationWrapper = (InputComponent) => (props) =>  {
    return <WithConfirmation>
        <InputComponent {...props} />
    </WithConfirmation>
};

export function WithConfirmation({ confirmation, response, lifetime, children, longButton = false }) {
    const [ confirmed, setConfirmed ] = React.useState(false);
    const [ processing, setProcessing ] = React.useState(false);
    const [ timer, setTimer ] = React.useState(null);

    React.useEffect(() => {
        if (!processing && confirmation) {
            setProcessing(true);
            setConfirmed(false);
            clearTimeout(timer);
        }

        if (!confirmed && processing && !confirmation) {
            setProcessing(false);
            setConfirmed(true);
            setTimer(setTimeout(() => setConfirmed(false), lifetime));
        }

        return () => clearTimeout(timer);
    }, [ confirmation, confirmed, processing, timer ]);

    let loader;

    if (processing) {
        loader = longButton ? <span className="svg-reset-no-circle spin"/> : <div><span className="btn-add-to-cart__holder svg-reset-red-circle-xxl spin"/></div>
    } else if (confirmed && response) {
        loader = longButton ? <span className="svg-check-mark-white"/> : <div><span className="btn-add-to-cart__holder svg-check-mark-green-circle-xxl"/></div>
    } else if (confirmed) {
        loader = longButton ? <span className="svg-cross-white"/> : <span className="btn-add-to-cart__holder svg-cross-red-circle"/>
    }

    return <>
        {loader}
        <div style={(loader && !longButton) ? {height: '0px', visibility: 'hidden', width: '0px' } : (loader && longButton) ? {visibility: 'hidden'} : {}}>{children}</div>
    </>
}

WithConfirmation.propTypes = {
    confirmation: PropTypes.bool,
    lifetime: PropTypes.number
};

WithConfirmation.defaultProps = {
    confirmation: false,
    lifetime: 3000
};
